import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { forwardRef } from "react";
import { genericHashLink, HashLink } from "react-router-hash-link";
import GatsbyLink from "gatsby-link";
import atomize from "@quarkly/atomize";
import { commonTextProps, commonTextPropsDefaults } from "./text";

var GatsbyHashLink = function GatsbyHashLink(props) {
  return genericHashLink(props, GatsbyLink);
};

var getQAPI = function getQAPI() {
  var globalThis = null;

  if (typeof window !== "undefined") {
    globalThis = window;
  } else if (typeof global !== "undefined") {
    globalThis = global;
  } else {
    return {};
  }

  if (!globalThis.QAPI) {
    return {};
  }

  return globalThis.QAPI;
};

var isAbsoluteURL = function isAbsoluteURL(url) {
  if (typeof url !== "string") {
    return false;
  } // Don't match Windows paths `c:\`


  if (/^[a-zA-Z]:\\/.test(url)) {
    return false;
  } // Scheme: https://tools.ietf.org/html/rfc3986#section-3.1
  // Absolute URL: https://tools.ietf.org/html/rfc3986#section-4.3


  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url);
};

var A = forwardRef(function (props, ref) {
  var _props$href = props.href,
      href = _props$href === void 0 ? "" : _props$href,
      rest = _objectWithoutProperties(props, ["href"]);

  var _getQAPI = getQAPI(),
      projectType = _getQAPI.projectType,
      mode = _getQAPI.mode;

  var Link = projectType === "gatsby" ? GatsbyHashLink : HashLink;

  if (mode !== "development" && isAbsoluteURL(href)) {
    return React.createElement("a", _extends({
      href: href,
      ref: ref
    }, rest));
  }

  return React.createElement(Link, _extends({
    to: href,
    ref: ref
  }, rest));
});
export default atomize(A)({
  name: "Link",
  effects: {
    link: ":link",
    hover: ":hover",
    visited: ":visited",
    active: ":active"
  },
  normalize: true,
  mixins: true,
  description: {
    en: "Text element — text in different variants: paragraph, heading, etc.",
    ru: "Элемент text — текст в различных вариантах: параграф, заголовок, и другие"
  },
  propInfo: _objectSpread({
    href: {
      weight: 1,
      control: "input",
      category: "Main",
      description: {
        en: "href — destination address where the link takes to",
        ru: "href — адрес назначения, по которому направляет ссылка"
      }
    },
    target: {
      weight: 1,
      control: "select",
      variants: ["_self", "_blank", "_parent", "_top"],
      category: "Main"
    }
  }, commonTextProps)
}, commonTextPropsDefaults);